<template>
  <div class="artists">
    <VideoBanner v-if='$route.name === "Artists"' posterSrc='artist.jpg' mp4Src='artist.mp4' webmSrc='artist.webm' :overlayTitle='$COMPANY.NAME' :overlayDescription='$COMPANY.DESCRIPTION' />
    <div class="main-content small-content">
      <b-container>
        <h2>Artister &amp; Band</h2>
        <div class="artists-content page-content">
          <b-row>
            <b-col>
              <h3>Musik som lyfter ditt evenemang</h3>
              <p>Oavsett om du planerar en fest, ett företagsevent, ett bröllop eller en större konsert ser vi till att du får rätt artist eller band anpassat efter just din publik och den stämning du vill skapa. Med vår långa erfarenhet och breda kontaktnät guidar vi dig hela vägen.</p>
              <h3>Smidigt, tryggt och anpassat efter dina behov</h3>
              <p>Berätta för oss om ditt evenemang , vad du planerar, vilken typ av musik du gillar och vilken känsla du vill förmedla. Så återkommer vi med skräddarsydda förslag. Vi tar hand om bokningen och alla praktiska detaljer så att du kan fokusera på upplevelsen.</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import VideoBanner from './VideoBanner'

export default {
  components: {
    VideoBanner
  }
}
</script>

<style>

</style>
